"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterUnpredictableUtf8Characters = void 0;
var patterns_1 = require("./patterns");
exports.filterUnpredictableUtf8Characters = function (text) {
    return patterns_1.patterns.reduce(function (result, c) { return result.replace(c, ''); }, text);
};
//# sourceMappingURL=filterUnpredictableUtf8Characters.js.map